<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencairan Saldo</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="py-0">
				<v-alert type="info" text class="my-2">
					<small style="line-height: normal;">Minimal Pencairan saldo adalah sebesar<br><b>{{ limit | toRupiah }}</b></small>
				</v-alert>
			</v-card-text>
			<v-card-text>
				<v-col class="pa-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-currency-field 
								label="Nominal saldo yang dicairkan"
								hide-details="auto"
								color="primary"
								prefix="Rp "
								v-model="params.nominal.value"
								:rules="rules.input"
								:error-messages="(errorValidation !== undefined && errorValidation['balance'] !== undefined ) ? [errorValidation['balance']] : []"
								@keypress="onlyNumber"
							></v-currency-field>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="d-flex justify-end">
				<v-col cols="12" class="d-flex align-center justify-end">
					<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses || (params.nominal.value < limit)" @click="proses">
						<v-icon dense class="mr-1">mdi-swap-vertical-bold</v-icon>
						<span>Proses</span>
					</v-btn>
					<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="cancelWithdraw">Batal</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			btnLoadingProses: false,
			limit: 200000,
			params: {
				nominal: {
					type:'float',
					field:'balance',
					value:''
				},
			},
			rules: {
				input: [
					v => !!v || 'Nominal pencairan saldo tidak boleh kosong',
					v => (v.replaceAll('.', '') >= this.limit) || 'Nominal pencairan minimal Rp200.000,-'
				],
			}
		}
	},
	computed:{
		...mapState('ewallet', ['errorValidation']),
	},
	methods :{
		modalShow() {
			this.reset()
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		stopLoading() {
			this.btnLoadingProses = false
		},
		reset() {
			this.params.nominal.value = ''
		},
		async proses() {
			if ( this.params.nominal.value) {
				this.btnLoadingProses = await true
				this.$emit('action', this.params)
			}
		},

		cancelWithdraw() {
			this.params.nominal.value = ''
			this.modalHide()
		}
	}
};
</script>